import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { replayQueue, pendingCount } from '../lib/syncQueue';

const NetworkContext = createContext({ online: true, pendingSyncs: 0 });

export function NetworkProvider({ children }) {
  const [online, setOnline] = useState(navigator.onLine);
  const [pendingSyncs, setPendingSyncs] = useState(0);

  const refreshPending = useCallback(async () => {
    setPendingSyncs(await pendingCount());
  }, []);

  useEffect(() => {
    const goOnline = async () => {
      setOnline(true);
      await replayQueue(supabase);
      await refreshPending();
    };
    const goOffline = () => setOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    refreshPending();

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, [refreshPending]);

  return (
    <NetworkContext.Provider value={{ online, pendingSyncs, refreshPending }}>
      {children}
    </NetworkContext.Provider>
  );
}

export function useNetworkStatus() {
  return useContext(NetworkContext);
}
